module.exports = __webpack_public_path__ + "static/media/moh-logo-new.843e1079.svg";